/*

THIS IS THE COMPONENT THAT WILL BE USED TO RENDER THE APP HEADER

*/


import React, { useRef } from 'react';
import './AppHeader.css';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';

const AppHeader = () => {
  const frontConfig = useSelector(state => state.frontConfigReducer);
  const checkoutStep = useSelector(state => state.navigationReducer.checkoutStep);
  const headerRef = useRef(null);
  let background;

  if (frontConfig.background) {
    background = frontConfig.background;
  } else {
    background = process.env.PUBLIC_URL + "/default-header.jpg"
  }

  useEffect(() => {
    headerRef.current.scrollIntoView({ behavior: 'smooth' })
  }, [checkoutStep])

  // console.log(frontConfig);

  return (
    <div ref={headerRef} className="AppHeader" style={{ background: `url(${background}) no-repeat center`, backgroundSize: 'cover' }}>
      {
        frontConfig.logo !== "" ?
          <img src={frontConfig.logo} alt="logo" className="LogoImg" />
          : null
      }
    </div>
  )
};

export default AppHeader;
